import Service from "../Service";
const resource = "PrfCustomerTemplate/";

export default {
  pagination(obj, requestID) {
    return Service.post(resource + "paginationPrinterHistoryTemplate", obj, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "savePrinterHistoryTemplate", obj, {
      params: { requestID },
    });
  },
};
